module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('h2', {
    staticClass: "ui center aligned icon header"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v("\n    " + _vm._s(_vm._f("formatTime")(_vm.time)) + "\n    "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("PM")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18b84cab","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clock.vue
// module id = 22
// module chunks = 0